const getOr = require('lodash/fp/getOr');

const config = require('../config'); const apiConfig = require('../api-config');
const apiFactory = require('../resources/assets-common/api-factory');
const serviceFactory = require('../resources/assets-common/service-factory');
const routeAdderFactory = require('../resources/assets-common/route-adder-factory');
const parsePosition = require('../resources/assets-common/parse-position');
const parseTransaction = require('../resources/assets-common/parse-transaction');
const merge = require('lodash/fp/merge');

function parseFXForwardsPosition(position) {
  const p = path => getOr(null, path, position);

  return merge(
    parsePosition(position),
    {
      security: {
        name: p('assetDescription'),
      },
      valueDate: p('psValueDt'),
      fxForwardRate: p('psFwdRate'),
    }
  );
}

function parseFxForwardsTransaction(transaction) {
  const t = path => getOr(null, path, transaction);

  return merge(
    parseTransaction(transaction),
    {
      type: t('tranTypeDesc'),
      amount: parseFloat(t('netAmtTradeCcy')) || null,
    }
  );
}

function addRoutes({ requestHandler } = {}) {
  const api = apiFactory({
    requestHandler,
    baseUrl: `${config.baseUrl}/fx-forwards/${apiConfig.apiversion}/`,
    authToken: config.authToken,
    assetCategory: '2',
    positionsUrl: 'fx-forwards-positions',
    transactionsUrl: 'fx-forwards-transactions',
    valueMovementUrl: 'fx-forwards-value-movement',
  });

  const service = serviceFactory({
    api,
    parsePosition: parseFXForwardsPosition,
    parseTransaction: parseFxForwardsTransaction,
  });

  return routeAdderFactory({ assetType: 'fxForwards', service });
}

module.exports = addRoutes;

